import React from 'react';
import { useSelector } from 'react-redux';
import getFrameUpsellFrameDescription from 'store/product/selector/getFrameUpsellFrameDescription';
import styles from './FrameDescription.module.scss';

const FrameDescription = () => {
  const frameDescription = useSelector(getFrameUpsellFrameDescription);
  return <div className={styles.frameDescription}>{frameDescription}</div>;
};

export default FrameDescription;
